import * as React from "react";
import { forwardRef } from "react";
const SvgIconConversationsSnoozed = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13 4a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 1.5A7.5 7.5 0 1 1 5.5 13 7.49 7.49 0 0 1 13 5.5M12.25 7v6.75h5.25v-1.5h-3.75V7z", transform: "translate(-4 -4)", fill: "#57728a" }));
const ForwardRef = forwardRef(SvgIconConversationsSnoozed);
export { ForwardRef as ReactComponent };
